import { UrlConstants } from "../url.constants";
export class ApiModuleTemplateConstants {
    static URL = UrlConstants.API_V2 + "ModuleTemplate";
}
